import styled from 'styled-components'

export const Container = styled.div`
  padding: 0 12px;

  > button {
    width: 100%;
    margin-top: 30px;
  }

  > div {
    gap: 20px;
  }
`